<template>
  <section class="container py-3">
    <template v-if="!loading">
      <template v-if="!survey">
        <b-form-group label="คุณแม่บ้านสนใจลงทะเบียน งานบริการล้างห้องน้ำ หรือไม่">
          <b-form-radio v-model="interested" name="interested-radios" :value="1"
            >สนใจลงทะเบียน</b-form-radio
          >
          <b-form-radio v-model="interested" name="interested-radios" :value="0"
            >ไม่สนใจลงทะเบียน</b-form-radio
          >
        </b-form-group>
        <b-form-group
          label="เหตุผลที่ไม่สนใจลงทะเบียน"
          v-if="interested === 0"
        >
          <b-form-radio
            v-model="uninterestedReason"
            name="radios-training-center"
            v-for="(item, index) in uninterestedReasonOptions"
            :key="index"
            :value="item.value"
          >
            {{ item.text }}
          </b-form-radio>
        </b-form-group>
        <button
          type="button"
          class="btn btn-success my-1 btn-block"
          :disabled="checkIsInvalid()"
          @click="save()"
        >
          บันทึก
        </button>
      </template>
      <template v-else>
        <div class="text-center ">
          <i class="fal fa-check-circle fa-7x text-success"></i>
          <div class="pt-3">
            <label>คุณแม่บ้านได้บันทึกข้อมูลเรียบร้อยแล้ว</label>
            <br />
            <label>คุณแม่บ้านสามารถกดออกจากหน้านี้ได้เลยค่ะ</label>
          </div>
        </div>
      </template>
    </template>
    <template v-else>
      <div class="text-center">
        <b-spinner variant="primary" label="Text Centered"></b-spinner>
      </div>
    </template>
  </section>
</template>
<script>
import axios from 'axios'

export default {
  data: () => ({
    professionalId: null,
    accessToken: null,
    surveyType: 'bathroom_cleaning_01',
    interested: null,
    uninterestedReason: null,
    uninterestedReasonOptions: [
      { text: 'ไม่คุ้มค่าเดินทาง', value: 'ไม่คุ้มค่าเดินทาง' },
      { text: 'ไม่สะดวกในการทำความสะอาดห้องน้ำ เช่น กลิ่นในห้องน้ำ กลิ่นของน้ำยาทำความสะอาด', value: 'ไม่สะดวกในการทำความสะอาดห้องน้ำ เช่น กลิ่นในห้องน้ำ กลิ่นของน้ำยาทำความสะอาด' },
      { text: 'ไม่ชอบการอยู่ที่แคบนาน ๆ', value: 'ไม่ชอบการอยู่ที่แคบนาน ๆ' },
      { text: 'ต้องการทราบข้อมูลเพื่อพิจารณาเพิ่มเติม', value: 'ต้องการทราบข้อมูลเพื่อพิจารณาเพิ่มเติม' }
    ],
    survey: null,
    loading: true
  }),
  watch: {
    interested (n, o) {
      if (n === 1) {
        this.uninterestedReason = null
      }
    }
  },
  methods: {
    checkIsInvalid () {
      let isError = true
      if (this.interested === 1 || (this.interested === 0 && this.uninterestedReason)) {
        isError = false
      }
      return isError
    },
    async save () {
      let data = {
        interested: this.interested
      }
      if (!this.interested) {
        data.uninterested_reason = this.uninterestedReason
      }
      const params = {
        professional_id: this.professionalId,
        data: data,
        type: this.surveyType
      }
      const config = {
        headers: { Authorization: this.accessToken }
      }
      try {
        this.loading = true
        const { data } = await axios.post('/surveys', params, config)
        this.loading = false
        if (!data.error) {
          this.$swal('Success', 'บันทึกเรียบร้อย', 'success')
          let professionalId = this.$route.query.professional_id
          this.fetchSurvey(professionalId)
        } else {
          this.$swal('Error', data.message, 'error')
        }
      } catch (error) {
        this.$swal('Error', error.message, 'error')
      }
    },
    async fetchSurvey () {
      const url = `surveys/${this.professionalId}`
      const params = {
        survey_type: this.surveyType
      }
      const { data } = await axios.get(url, { params, headers: { Authorization: this.accessToken } })
      this.loading = false
      if (!data.error) {
        this.survey = data.survey
      }
    }
  },
  created () {
    this.professionalId = this.$route.query.professional_id
    if (this.$route.query.access_token) {
      this.accessToken = `Bearer ${this.$route.query.access_token}`
    }
    if (this.professionalId && this.accessToken) {
      this.fetchSurvey()
    } else {
      this.$swal({ text: 'Invalid user', type: 'error' })
    }
  }
}
</script>
<style scoped>
.custom-control {
  padding-bottom: 0.75rem !important;
  padding-top: 0.75rem !important;
}
</style>



// WEBPACK FOOTER //
// src/components/survey/BathroomCleaningForm.vue